/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import book from "../../../images/book.png";
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const [projectitems, setProjects] = useState([]);

  const fetchProjects = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/list",
         {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("user")}`,
                "Content-Type": "application/json",
            },
        }
      );
      const data = await res.json();
      setProjects(data.projects);
    } catch (err) {
      console.error("فشل في جلب الكليات", err);
    }
  };

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    fetchProjects();
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    // var handleheartBlast = document.querySelector('.heart');
    //       function heartBlast() {
    //           return handleheartBlast.classList.toggle("heart-blast");
    //       }

    //       handleheartBlast.addEventListener('click', heartBlast);
    // fetchColleges();
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let fullPath = window.location.pathname;
  const isProjectsActive = fullPath.includes("/projects");
  const isCollegesActive = fullPath.includes("/colleges");
  /// Active menu
  let projects = ["projects"],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-media-object",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
    ],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];

  return (
    <div
  
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll mt-5">
        <MM className="metismenu" id="menu">
          <li className={`${path === "" ? "mm-active" : ""}`}>
            <Link to="/">
              <i className="flaticon-381-home"></i>
              <span className="nav-text">لوحة التحكم</span>
            </Link>
          </li>

          <li className={`${isProjectsActive ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">المشاريع</span>
            </Link>
            <ul aria-expanded="false">
              {projectitems.map((p) => (
                <li key={p.id}>
                  <Link to={`/projects/detailes/${p.project_id}`}>{p.project_name} - {p.company_name}</Link>
                </li>
              ))}
            </ul>
          </li>

          {/* <li className={`${isProjectsActive ? "mm-active" : ""}`}>
            <Link to="/projects" className="mt-1">
              <i className="fa fa-bar-chart"></i>
              <span className="nav-text">المشاريع</span>
            </Link>
          </li> */}
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
